import { useProjectExperimentationSettings } from '@gonfalon/experiments/useProjectExperimentationSettings';
import { useProjectKey } from '@gonfalon/router/useProjectKey';

export function useRandomizationUnit(randomizationUnit?: string) {
  const projectKey = useProjectKey();
  const queryResult = useProjectExperimentationSettings({ projectKey, enabled: !!randomizationUnit });
  if (queryResult.isPending || queryResult.isError) {
    return { ...queryResult, data: undefined };
  }
  const data = queryResult.data.randomizationUnits?.find((unit) => unit.randomizationUnit === randomizationUnit);
  if (!data) {
    return {
      ...queryResult,
      data: undefined,
      isError: true,
      error: new Error(`Randomization unit not found: ${randomizationUnit}`),
    };
  }
  return { ...queryResult, data };
}
